;(function(){
	if (!$("body").hasClass("post-type-archive-adac_press")) return;

	console.log("press.js");
	
	$("body").on("click", ".load_more", function(e) {
		e.preventDefault();

		var $el = $(this).parents("ul");

		$el.find(".loading").show();
		$el.find(".load_more").remove();

		$.ajax($(this).attr("href"), {
			method: "GET",
		}).done(function(data, textStatus, jqXHR) {
			window.ajaxdata = data;
			console.log(data);
			$el.find(".cf").remove();
			$el.append(data);
		})
	})


	$("body").on("click", ".youtube", function() {
		$("body > .embed-container, body > .embed-container-overlay").remove();
		$("<div class='embed-container-overlay'></div>").appendTo("body");
		$(this).parents("li").find(".embed-container").clone().appendTo("body");
	})


	$("body").on("click", ".embed-container-overlay", function() {
		$("body > .embed-container, body > .embed-container-overlay").remove();
	})

	$(window).on("keydown", function(e) {
		if(e.keyCode == 27) $("body > .embed-container, body > .embed-container-overlay").remove();
	})

})();